import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import helper from "../../utils/helpers";
import { isEmpty } from "lodash";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const AttendanceReportTable = ({ employeeList, page = 1, pageSize = 10 }) => {
  const { t } = useTranslation();

  // Helper function to format time
  const formatTime = (dateTime) => {
    if (!dateTime) return "-";
    return dayjs(dateTime).format("h:mm:ss A");
  };

  // Helper function to format date
  const formatDate = (dateTime) => {
    if (!dateTime) return "-";
    return dayjs(dateTime).format("MM-DD-YYYY");
  };
  const attendanceLabel = (item) => {
    const noPunch = !item?.punchInDateTime && !item?.punchOutDateTime;
    const onLeave = item?.attendanceStatus === "on_leave_paid" || item?.attendanceStatus === "on_leave_unpaid";
    const entryDay = item?.createdAt || item?.date;
    const isPastDay = entryDay && dayjs(entryDay).format("YYYY-MM-DD") < dayjs().format("YYYY-MM-DD");
    if (item?.attendanceStatus === "absent" || item?.isAbsent || (noPunch && isPastDay && !onLeave)) return "Absent";
    if (item?.attendanceStatus === "present") return "Present";
    if (onLeave) return "On leave";
    return "-";
  };

  // Calculate starting serial number for current page
  const startSerialNumber = (page - 1) * pageSize;

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("SNO")} />
                <TableHeaderCell text={t("DATE")} />
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("EMPLOYEE_ID")} />
                <TableHeaderCell text={t("PUNCH_IN_TIME")} />
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex justify-start">
                    <span>{t("PUNCH_IN_LOCATION")}</span>
                  </div>
                </th>
                <TableHeaderCell text={t("PUNCH_OUT_TIME")} />
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex justify-start">
                    <span>{t("PUNCH_OUT_LOCATION")}</span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("TOTAL_BREAK_TIME")}
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("WORKING_HOURS")}
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("ATTENDANCE_STATUS")}
                </th>
              </tr>
            </thead>
            <tbody>
              {employeeList &&
                employeeList.map((item, i) => {
                  // Calculate serial number based on page and pageSize
                  const serialNumber = startSerialNumber + i + 1;

                  return (
                    <tr key={i} className="dark:bg-gray-800 bg-white border-b dark:border-gray-700">
                      <td className="py-4 px-6 text-gray-900 border-r">
                        {serialNumber}
                      </td>
                      <td className="py-4 px-6 text-gray-900 border-r">
                        {formatDate(item?.createdAt)}
                      </td>
                      <td className="text-gray-900 py-4 px-6 border-r">
                        {item?.employee?.name || "-"}
                      </td>
                      <td className="px-6 border-r py-4 text-gray-900">
                        {item?.employee?.employeeId || "-"}
                      </td>
                      <td className="py-4 border-r text-gray-900 px-6">
                        {formatTime(item?.punchInDateTime)}
                      </td>
                      <td className="border-r py-4 px-6 text-gray-900">
                        {item?.punchInLocation || "-"}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {formatTime(item?.punchOutDateTime)}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.punchOutLocation || "-"}
                      </td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">
                        {item?.breakTimeDisplay || "-"}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.workTimeDisplay || "-"}
                      </td>
                      <td
                        className={`py-4 px-6 font-semibold ${attendanceLabel(item) === "Present"
                            ? "text-blue-600"
                            : attendanceLabel(item) === "Absent"
                              ? "text-red-600"
                              : "text-gray-900"
                          }`}
                      >
                        {attendanceLabel(item)}
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(employeeList) ? (
                <tr className="dark:bg-gray-800 bg-white border-b text-center dark:border-gray-700">
                  <td className="colSpan={10} px-6 border-r py-4">
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AttendanceReportTable;